import { DropDownIcon } from "../svg/icons/icon";
import { useState , useRef , useEffect, forwardRef } from "react";
import {CrossIcon} from '../svg/icons/icon'

// function Input ({label , placeholder , type , options , onChange , name , value}) {
//    return (
//     <>
//      <div class="w-full flex flex-col-reverse">
//   {type == "select" ?
//      <select
//      className=" py-2 px-6 w-full  rounded-lg
//        text-md text-gray-900 outline-none bg-[#F1F5F8]"
//        name = {name}
//        value = {value}
//        onChange = {onChange}
//    >
//      <option value="" disabled selected>
//         {placeholder} 
//      </option>
//      {options &&
//        options.map((option, index) => (
//          <option key={index} value={option.value}>
//            {option.label}
//          </option>
//       ))}
//    </select>
//         :
//   <input 
//       type = {type} 
//       className=" bg-[#F1F5F8] rounded-lg px-4 py-2  w-full  
//             text-md text-gray-900 outline-none " 
//       placeholder={placeholder} 
//       onChange = {onChange}
//       name = {name}
//       value = {value}
//     />
// }


    
//      <label 
//       className="text-[14px] font-bold  "
//     >
//       {label}
//         </label>
//     </div>
//     </>
//    )
// }
// export default Input







function Input({ label, placeholder, type, options, onChange, name, value, required }) {
  const commonClasses =
    "bg-white rounded-lg px-2 py-2 w-full text-sm text-gray-900 placeholder-gray-500 placeholder-opacity-50 outline-none ";

  // Get today's and yesterday's date in "YYYY-MM-DD" format
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  // const formattedYesterday = yesterday.toISOString().split("T")[0];
  // const formattedToday = today.toISOString().split("T")[0];

  const formatDate = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate())
      .toLocaleDateString("en-CA" , {timezone : "UTC"}) // "en-CA" ensures YYYY-MM-DD format
      .replace(/\//g, "-"); // Ensures correct formatting
  };
  
  const minDate = formatDate(yesterday); // Yesterday's date
  const maxDate = "";
  return (
    <div className="flex flex-col-reverse">
      {type === "select" ? (
        <div className="relative ">
          <select
            className={`${commonClasses} py-[12px]`}
            name={name}
            value={value}
            onChange={onChange}
          >
            <option value="">Select an option</option> {/* Default empty option */}
            {options &&
              options.map((option, index) => (
                <option key={index} value={option.description}>
                  {option.description}
                </option>
              ))}
          </select>
        </div>
      ) : type === "date" ? (
        <input
          type="date"
          className={`${commonClasses} `}
          onChange={onChange}
          name={name}
          value={value}
          min={minDate} 
          max = {maxDate}
          placeholder={placeholder}
        />
      ) : (
        <input
          type={type}
          className={commonClasses}
          placeholder={placeholder}
          onChange={onChange}
          name={name}
          value={value}
        />
      )}

      <label className="text-sm mb-2 font-bold">
        {label}
        {required && <span className="text-red-500">*</span>}
      </label>
    </div>
  );
}



function RadiusSelect({ label, placeholder, options, onChange, name, value , required ,disabled }) {
  // const commonClasses =
  //   "bg-[#F1F5F8] rounded-r-lg  px-2 py-3 w-full text-sm text-gray-900 outline-none ";
  const commonClasses =
  "bg-white px-2 py-3 w-full text-sm rounded-r-lg text-gray-900 outline-none";


  return (
    <div className="flex flex-col-reverse">
     
        <div className="relative ">
          <select
            className={`${commonClasses} py-[13px]`}
            name={name}
            value={value}
            onChange={onChange}
            disabled = {disabled}
          >
            {/* <option value="" >
           {placeholder}
            </option> */}
            {options &&
              options.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
          </select>
          {/* Dropdown Icon */}
          {/* <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
            <DropDownIcon />
          </div> */}
        </div>
        {/* <label className="text-sm mb-2 font-bold">{label}
          {required && <span className="text-red-500">*</span>}
        </label> */}
    </div>
  );
}

const RadiusInput = ({
  label,
  type,
  options,
  name,
  onChange,
  radiusOptions,
  radiusName,
  onRadiusChange,
  radiusValue,
})  =>{
  const [searchTerm, setSearchTerm] = useState("");
  const[selectedValue , setSelectedValue] = useState("")
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [radiusDropdownVisible, setRadiusDropdownVisible] = useState(false);
  const [selectedRadius, setSelectedRadius] = useState(radiusValue || ""); // Initialize with default or empty
  const dropdownRef = useRef(null);
  const radiusDropdownRef = useRef(null);

  const filteredOptions = options?.filter((option) => {
    if (typeof option === "object" && option.label) {
      return option.label.toLowerCase().includes(searchTerm.toLowerCase());
    }
    if (typeof option === "string") {
      return option.toLowerCase().includes(searchTerm.toLowerCase());
    }
    return false;
  });

  const leftClasses =
    "bg-[#F1F5F8] rounded-l-lg px-2 py-3 w-full text-sm text-gray-900 outline-none";

  const rightClasses =
    "bg-[#F1F5F8] rounded-r-lg px-2 py-3 w-full text-sm text-gray-900 outline-none";

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownVisible(false);
      }
      if (
        radiusDropdownRef.current &&
        !radiusDropdownRef.current.contains(event.target)
      ) {
        setRadiusDropdownVisible(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, []);

  return (
    <div className="flex flex-col">
      <label className="text-sm font-bold">{label}</label>
      <div className="flex items-center space-x-1">
        {type === "select" && (
          <>
            {/* Left Searchable Dropdown */}
            <div className="relative w-64" ref={dropdownRef}>
              <input
                type="text"
                placeholder="Search..."
                className={` ${leftClasses}`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onFocus={() => setDropdownVisible(true)}
              />

              {dropdownVisible && (
                <div
                  className="absolute left-0 mt-1 top-full z-50 w-full bg-white shadow-lg rounded-md overflow-y-auto"
                  style={{
                    maxHeight: "200px",
                  }}
                >
                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((option, index) => (
                      <div
                        key={index}
                        className="px-4 mx-2 my-1 py-2 text-sm text-gray-800 cursor-pointer hover:bg-gray-100"
                        onClick={() => {
                        //   setSelectedValue(option.value)
                        //   setSearchTerm(
                        //     typeof option === "object" ? option.label : option
                        //   );
                        //   setDropdownVisible(false);
                        // }}
                        const value = typeof option === "object" ? option.value : option;
                          setSelectedValue(value);
                          setSearchTerm(
                            typeof option === "object" ? option.label : option
                          );
                          setDropdownVisible(false);

                          // Trigger the parent handler
                          if (onChange) {
                            onChange({ target: { name: name, value } });
                          }
                        }}
                      >
                        {typeof option === "object" ? option.label : option}
                      </div>
                    ))
                  ) : (
                    <div className="px-4 py-2 text-sm text-gray-500">
                      No options found
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Right Dropdown */}
            <div
              className="relative flex-grow"
              ref={radiusDropdownRef}
              onClick={() =>
                setRadiusDropdownVisible((prev) => !prev)
              }
            >
              <div
                className={`cursor-pointer ${rightClasses}`}
              >
                {selectedRadius || "Select Radius"}
              </div>

              {radiusDropdownVisible && (
                <div
                  className="absolute mt-1 top-full left-0 z-50 w-full bg-white shadow-lg rounded-md"
                  style={{
                    maxHeight: "200px",
                    overflowY: "auto",
                  }}
                >
                  {radiusOptions &&
                    radiusOptions.map((option, index) => (
                      <div
                        key={index}
                        className="px-2 py-2 text-sm text-gray-800 cursor-pointer hover:bg-gray-100"
                        onClick={() => {
                          setSelectedRadius(option.label);
                          setRadiusDropdownVisible(false);
                          // if (onRadiusChange) {
                          //   onRadiusChange(option.value);
                          // }
                          if (onRadiusChange) {
                            onRadiusChange({ target: { name: radiusName, value: option.value } });
                          }
                        }}
                      >
                        {option.label}
                      </div>
                    ))}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}


function Filter({ label, options, name, value, onChange }) {
  const selectedOption = options?.find((option) => option.value === value);

  return (
    <div className="relative inline-block">
      {selectedOption && (
        <div className="absolute inset-0 flex px-1 items-center justify-center pointer-events-none">
          <span className="">
            <span className = "text-[#737373]">{label}:</span> <span className = "p-2">{selectedOption.value}</span>
          </span>
        </div>
      )}
      <select
        className="bg-transparent border border-2 border-[#D4D4D4] rounded-lg px-4 py-1 text-[#737373]  focus:outline-none "
        name={name}
        value={value}
        onChange={onChange}
      >
        <option value="" disabled>
           {label}
        </option>
        {options &&
          options.map((option, index) => (
            <option key={index} value={option.value} 
            style={{ display: value === option.value ? "none" : "block" }}>
              {option.label}
            </option>
          ))} 
      </select>
      {/* Show selected label and value */}
      
    </div>
  );
}


function Filter1({name ,  onClick , value , units , onChange , label}) {
const [internalValue, setInternalValue] = useState(value);

useEffect(() => {
  setInternalValue(value);
}, [value]);

const handleClear = (e) => {
  e.stopPropagation();

  const resetValue = name == "broker" ? "" : 0; 
  setInternalValue(resetValue); 

  if (onChange) {
    onChange({ target: { name, value: resetValue } });
  }
};

  return (
    <div className="relative inline-block">
  
      <div
        className="flex gap-1 bg-transparent border border-1 border-[#D4D4D4] rounded-lg px-4 py-1 text-[#737373] cursor-pointer  focus:outline-dashed "
        onClick={onClick}
      >
        {internalValue == 0 || internalValue == "" ? <span >{label}</span> 
        :
        <>
      <span className = "text-sm  pt-[0.5px] items-center">{label}:</span>
      <div className = "text-[#258CFB] flex gap-1">
      <span className = "">{internalValue}</span><span>{units}</span>
      <span className= "p-2 " 
      onClick = {handleClear}
      >
        <CrossIcon />
      </span>
      </div>
      </>
        }
      </div>
      
    </div>
  );
}

function SearchSelect({
  label,
  type,
  options,
  onClick
}) {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredOptions = options.filter((option) => {
    if (typeof option === "object" && option.CompanyName) {
      return option.CompanyName.toLowerCase().includes(searchTerm.toLowerCase());
    }
    if (typeof option === "string") {
      return option.toLowerCase().includes(searchTerm.toLowerCase());
    }
    return false;
  });

  const leftClasses =
    "bg-[#F1F5F8] rounded-lg px-2 py-3 w-full text-sm text-gray-900 outline-none";

useEffect(() =>{
  console.log(searchTerm , "search term")
},[searchTerm])
  return (
    <div className="absolute flex  flex-col">
      <div className="flex border border-2  bg-white items-center space-x-1">
        {type === "select" && (
          <>
            <div className="absolute w-64 left-[-95px] rounded-t-lg  pt-4 pr-4 pl-4  pb-2 bg-white top-10" 
            >
              <input             
                type="text"
                placeholder="Search..."
                className={` ${leftClasses}`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

                <div
                  className="absolute left-0 top-full z-50 w-full pb-2 px-2 rounded-b-lg  bg-white shadow-lg overflow-y-auto"
                  style={{
                    maxHeight: "200px",
                  }}
                >
                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((option, index) => (
                      <div
                        key={index}
                        className="px-4 mx-2 py-2 text-sm text-gray-800 cursor-pointer hover:bg-gray-100"
                        onClick={() => {
                          setSearchTerm(
                            typeof option === "object" ? option.CompanyName : option
                          );
                          onClick(typeof option === "object" ? option.CompanyName : option)
                          // setDropdownVisible(false);
                        }}
                      >
                        {typeof option === "object" ? option.CompanyName : option}
                      </div>
                    ))
                  ) : (
                    <div className="px-4 py-2 text-sm text-gray-500">
                      No options found
                    </div>
                  )}
                </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}


const LabelField = forwardRef(
  ({ label, labelDir, fieldSize, option, type, placeholder,required , ...rest }, ref) => {
    // const commonClasses =
    // "bg-[#F1F5F8] rounded-l-lg px-2 py-3 w-full text-sm text-gray-900 outline-none ";
    const commonClasses =
  "bg-white px-2 py-3 w-full text-sm text-gray-900 outline-none rounded-l-lg";


    return (
      <div className = "flex flex-col">
      <label
        className="text-sm mb-2 font-bold">{label}
        {required && <span className="text-red-500">*</span>}</label>
        {/* {label && <label className="mc-label-field-title">{label}</label>} */}
        <div className = "flex items-center space-x-1">
        {type ? (
          <input
            type={type || "text"}
            placeholder={placeholder || "Type here..."}
            className={`${commonClasses} ${fieldSize || "w-md h-sm"}`}
            style={type === "file" ? { background: "none", border: "none" } : {}}
            ref={ref}
            {...rest}
          />
        ) : (
          <select
            className={`mc-label-field-select ${fieldSize || "w-md h-sm"}`}
            {...rest}
          >
            {option.map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
          </select>
        )}
      </div>
      </div>
    );
  }
);




export default Input
export {RadiusInput , Filter , Filter1 , SearchSelect , LabelField , RadiusSelect};

